<template>
  <tr  :style="{ background: isGroup ? '#f2f6fc' : '' }">
    <td>
      <el-tooltip effect="dark" content="Select a field" placement="top-start">
        <el-select
          v-model="filter.field"
          placeholder="Select Field"
          clearable
          filterable
          size="mini"
          @change="
            (changedValue) => checkCurrentFieldData(changedValue, filter)
          "
        >
          <el-option
            v-for="(field, index) of allFormbuilderFields.filter(
              (e) =>
                e.input_type !== 'DATA_TABLE' && e.input_type !== 'ENTITY_TABLE'
            )"
            :key="index"
            :value="field.key"
            :label="field.label"
            >{{ field.label }}</el-option
          >
        </el-select>
      </el-tooltip>
    </td>
    <td>
      <el-tooltip effect="dark" content="Select operator" placement="top-start">
        <el-select
          v-model="filter.operator"
          size="mini"
          :disabled="!filter.field"
          placeholder="Operator"
        >
          <el-option
            v-for="(operator, index) of getCurrentFieldOperators(filter)"
            :key="index"
            :label="operator.title"
            :value="operator.value"
          ></el-option>
          <el-option
            v-if="filter.input_type == 'SELECT' && filter.data_type == 'ARRAY'"
            value="=text-includes"
            label="Text Includes"
          ></el-option>
        </el-select>
      </el-tooltip>
    </td>
    <td
      v-if="
        filter.operator != 'exists' &&
        filter.operator != 'notexists' &&
        filter.operator != 'between' &&
        filter.operator != 'notbetween' &&
        filter.operator != 'dateinclude' &&
        filter.operator != 'notdateinclude' &&
        filter.operator != 'real_time' &&
        filter.operator != 'weekdays' &&
        filter.operator != 'filter' &&
        filter.data_type !== 'STATUS'
      "
    >
      <el-tooltip
        effect="dark"
        content="Select value type"
        placement="top-start"
      >
        <el-select
          v-if="
            filter.operator != 'lastmonth' && filter.operator != 'thismonth'
          "
          v-model="filter.data_source"
          @change="(value) => checkSourceDataChange(value, filter)"
          size="mini"
          placeholder="Value type"
          :disabled="!filter.operator"
        >
          <el-option
            v-for="(source, index) of allowedDataSources(filter)"
            :key="index"
            :label="source"
            :value="source"
          ></el-option>
          <el-option
            value="TEMPLATE"
            label="Template"
            v-if="
              checkTemplateCondition(filter) &&
              filter.data_type != 'created_by' &&
              filter.data_type != 'updated_by' &&
              filter.data_type != 'created_at' &&
              filter.data_type != 'updated_at' &&
              filter.input_type != 'SELECT'
            "
          ></el-option>
          <el-option
            value="LOGIN_USER"
            label="Login User"
            v-if="
              filter.data_type == 'created_by' ||
              filter.data_type == 'updated_by'
            "
          ></el-option>
          <el-option
            v-if="filter.data_type == 'WEEKDAYS'"
            value="weekdays"
            label="Weekdays"
          ></el-option>
          <el-option
            v-if="checkIsSelect(filter)"
            value="field_option"
            label="From field"
          ></el-option>
          <el-option
            v-if="
              filter.data_type == 'STRING' &&
              allowedLoginFilterOp.indexOf(filter.operator) != -1
            "
            value="login_user"
            label="FROM LOGIN USER"
          ></el-option>
          <el-option
            v-if="
              filter.input_type == 'SELECT' &&
              filter.data_type == 'ARRAY' &&
              filter.operator == '=text-includes'
            "
            value="VALUE"
            label="Value"
          ></el-option>
        </el-select>
      </el-tooltip>
    </td>
    <td v-if="filter.operator != 'exists' && filter.operator != 'notexists'">
      <div>
        <el-select
          v-if="filter.data_source == 'TEMPLATE'"
          v-model="filter.value_field"
          size="mini"
          placeholder="Template fields"
        >
          <el-option
            v-for="(enityData, index) of getSelfTemplateFieldsByType(filter)"
            :key="index"
            :label="enityData.label"
            :value="enityData.key"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.value"
          v-if="
            filter.data_type == 'BOOLEAN' && filter.data_source != 'TEMPLATE'
          "
          size="mini"
        >
          <el-option :value="true" label="Checked"></el-option>
          <el-option :value="false" label="Unchecked"></el-option>
        </el-select>
        <el-select
          v-model="filter.value"
          v-if="
            filter.data_type == 'DATE' && filter.data_source == 'CURRENT_DATE'
          "
          size="mini"
        >
          <el-option value="today" label="Today"></el-option>
        </el-select>

        <el-select
          v-model="filter.value"
          v-if="
            filter.data_type == 'YES_OR_NO' && filter.data_source != 'TEMPLATE'
          "
          size="mini"
        >
          <el-option value="YES" label="Yes"></el-option>
          <el-option value="NO" label="No"></el-option>
        </el-select>
        <el-select
          v-model="filter.value"
          v-if="filter.data_type == 'DATE' && filter.operator == 'weekdays'"
          size="mini"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(option, index) of weekdays_options"
            :value="option.value"
            :label="option.name"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.value"
          v-if="
            filter.data_source == 'weekdays' && filter.data_type == 'WEEKDAYS'
          "
          size="mini"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(option, index) of weekdays_options"
            :value="option.key"
            :label="option.name"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.relational_filter_query"
          v-if="filter.data_type == 'RELATION' && filter.operator == 'filter'"
          :disabled="!checkIsFirstRelationalField(index)"
          @change="setRelationalFilterQuery"
          size="mini"
        >
          <el-option
            v-for="(item, index) in [
              { label: 'Includes', value: 'includes' },
              { label: 'Not includes', value: 'not_includes' },
            ]"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select
          v-model="filter.value_field"
          size="mini"
          v-if="filter.data_source == 'login_user'"
          @change="
            (changedValue) => checkCurrentFieldValue(changedValue, filter)
          "
        >
          <el-option
            v-for="(op, index) in loginUserFields"
            :key="index + op.value"
            :label="op.label"
            :value="op.value"
            >{{ op.label }}</el-option
          >
        </el-select>
        <el-input
          v-model="filter.value"
          v-if="
            filter.data_source == 'VALUE' &&
            (filter.data_type == 'STRING' ||
              (filter.input_type == 'SELECT' &&
                filter.data_type == 'ARRAY' &&
                filter.operator == '=text-includes'))
          "
          size="mini"
        ></el-input>

        <div
          v-if="
            (filter.data_type == 'NUMBER' || filter.data_type == 'CURRENCY') &&
            filter.operator == 'between'
          "
        >
          <el-input-number
            v-model="filter.range1"
            :controls="false"
            size="mini"
            placeholder="starting value"
            :min="0"
            style="margin-right: 15px"
          ></el-input-number>
          <span>To</span>
          <el-input-number
            v-model="filter.range2"
            :controls="false"
            size="mini"
            :min="0"
            placeholder="ending value"
            style="margin-left: 15px"
          ></el-input-number>
        </div>
        <!-- <el-input-number
                        v-model="filter.value"
                        v-if="
                          filter.data_type == 'DATE' &&
                          (filter.operator == 'after' ||
                            filter.operator == 'before')
                        "
                        :controls="false"
                        size="mini"
                    ></el-input-number>-->
        <div
          v-if="
            filter.data_type == 'DATE' &&
            (filter.operator == 'after' || filter.operator == 'before') &&
            filter.data_source == 'VALUE'
          "
          class="counter-box"
        >
          <el-input-number
            v-model="filter.value"
            size="mini"
            :min="1"
            style="width: 100px"
          ></el-input-number>
          <el-select
            v-model="filter.units"
            size="mini"
            style="width: 100px; margin-left: 4px"
          >
            <el-option value="days" label="Day(s)"></el-option>
            <el-option value="weeks" label="Week(s)"></el-option>
            <el-option value="months" label="Month(s)"></el-option>
            <el-option value="years" label="Year(s)"></el-option>
          </el-select>
        </div>
        <el-input-number
          v-model="filter.value"
          v-if="
            filter.data_source == 'VALUE' &&
            filter.data_type == 'NUMBER' &&
            filter.operator != 'between'
          "
          :controls="false"
          size="mini"
        ></el-input-number>
        <el-input-number
          v-model="filter.value"
          v-if="filter.data_source == 'VALUE' && filter.data_type == 'CURRENCY'"
          :controls="false"
          size="mini"
        ></el-input-number>
        <el-date-picker
          v-model="filter.value"
          size="mini"
          placeholder="Select Date"
          v-if="
            filter.data_source == 'VALUE' &&
            filter.data_type == 'DATE' &&
            filter.operator != 'real_time' &&
            filter.operator != 'between' &&
            filter.operator != 'weekdays' &&
            filter.operator != 'after' &&
            filter.operator != 'before'
          "
          :format="
            getDefaultDateFormat && getDefaultDateFormat.includes('Do') == false
              ? getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
              : 'MM-dd-yyyy'
          "
        ></el-date-picker>
        <el-time-picker
          v-model="filter.value"
          size="mini"
          placeholder="select time"
          v-if="
            filter.data_type == 'TIME_RANGE' && filter.operator == 'timeinclude'
          "
          :picker-options="{
            format: 'HH:mm:ss',
          }"
          :value-format="'HH:mm:ss'"
        ></el-time-picker>
        <el-date-picker
          v-model="filter.value"
          placeholder="Select Date"
          size="mini"
          v-if="
            filter.data_source == 'VALUE' &&
            filter.data_type == 'DATE_TIME' &&
            filter.operator != 'real_time' &&
            filter.operator != 'between' &&
            filter.operator != 'dateinclude' &&
            filter.operator != 'notdateinclude' &&
            filter.operator != 'weekdays'
          "
          :format="
            getDefaultDateFormat && getDefaultDateFormat.includes('Do') == false
              ? getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
              : 'MM-dd-yyyy'
          "
        ></el-date-picker>
        <el-date-picker
          v-model="filter.value"
          size="mini"
          v-else-if="
            filter.data_source == 'VALUE' && filter.data_type == 'created_at'
          "
          :format="
            getDefaultDateFormat && getDefaultDateFormat.includes('Do') == false
              ? getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
              : 'MM-dd-yyyy'
          "
        ></el-date-picker>
        <el-select
          v-if="
            filter.input_type === 'created_by' && filter.data_source === 'VALUE'
          "
          v-model="filter.value"
          size="mini"
          multiple
          collapse-tags
          style="margin-left: 10px"
        >
          <el-option
            v-for="(user, index) in users.data"
            :key="index"
            :label="user.email"
            :value="user._id"
          ></el-option>
        </el-select>
        <el-select
          v-if="
            filter.input_type === 'updated_by' && filter.data_source === 'VALUE'
          "
          v-model="filter.value"
          size="mini"
          multiple
          collapse-tags
          style="margin-left: 10px"
        >
          <el-option
            v-for="(user, index) in users.data"
            :key="index"
            :label="user.email"
            :value="user._id"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="filter.value"
          size="mini"
          v-else-if="
            filter.data_source == 'VALUE' && filter.data_type == 'updated_at'
          "
          :format="
            getDefaultDateFormat && getDefaultDateFormat.includes('Do') == false
              ? getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
              : 'MM-dd-yyyy'
          "
        ></el-date-picker>
        <el-date-picker
          v-model="filter.value"
          size="mini"
          v-if="
            (filter.data_type == 'DATE_TIME' ||
              filter.data_type == 'DATE_RANGE') &&
            filter.operator == 'dateinclude'
          "
          :format="
            getDefaultDateFormat && getDefaultDateFormat.includes('Do') == false
              ? getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
              : 'MM-dd-yyyy'
          "
        ></el-date-picker>
        <el-date-picker
          v-model="filter.value"
          size="mini"
          v-if="
            (filter.data_type == 'DATE_TIME' || filter.data_type == 'DATE') &&
            filter.operator == 'notdateinclude'
          "
          :format="
            getDefaultDateFormat && getDefaultDateFormat.includes('Do') == false
              ? getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
              : 'MM-dd-yyyy'
          "
        ></el-date-picker>
        <el-select
          v-if="
            filter.data_source == 'REAL_TIME_PICKER' &&
            filter.data_type == 'DATE_TIME' &&
            filter.operator != 'real_time' &&
            filter.operator != 'between' &&
            filter.operator != 'weekdays'
          "
          placeholder="Pick date range"
          v-model="filter.selected_date_picker"
          size="mini"
          @change="(changedValue) => setDatePickerDate(changedValue, filter)"
        >
          <el-option label="Today" value="today">Today</el-option>
          <el-option label="Yesterday" value="yesterday">Yesterday</el-option>
        </el-select>
        <CustomDatePicker
          v-if="filter.data_type == 'DATE' && filter.operator == 'real_time'"
          :field="filter"
        ></CustomDatePicker>
        <el-date-picker
          v-if="filter.data_type == 'DATE' && filter.operator == 'between'"
          v-model="filter.value"
          size="mini"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
        ></el-date-picker>
        <el-date-picker
          v-if="filter.data_type == 'DATE' && filter.operator == 'notbetween'"
          v-model="filter.value"
          size="mini"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
        ></el-date-picker>

        <el-time-picker
          is-range
          v-if="
            filter.data_type == 'TIME' &&
            filter.operator == 'between' &&
            isFixed(filter) === false
          "
          v-model="filter.value"
          size="mini"
          range-separator="To"
          start-placeholder="Start time"
          end-placeholder="End time"
          :picker-options="{
            format: 'HH:mm:ss',
          }"
          :value-format="'HH:mm:ss'"
        ></el-time-picker>
        <el-time-picker
          is-range
          v-if="
            filter.data_type == 'TIME' &&
            filter.operator == 'notbetween' &&
            isFixed(filter) === false
          "
          v-model="filter.value"
          size="mini"
          range-separator="To"
          start-placeholder="Start Time"
          end-placeholder="End Time"
          :picker-options="{
            format: 'HH:mm:ss',
          }"
          :value-format="'HH:mm:ss'"
        ></el-time-picker>
        <el-time-picker
          is-range
          v-if="
            filter.data_type == 'TIME' &&
            filter.operator == 'between' &&
            isFixed(filter) === true
          "
          v-model="filter.value"
          size="mini"
          range-separator="To"
          start-placeholder="Start Time"
          end-placeholder="End Time"
          :picker-options="{
            format: 'HH:mm:ss',
          }"
          :value-format="'HH:mm'"
        ></el-time-picker>
        <el-time-picker
          is-range
          v-if="
            filter.data_type == 'TIME' &&
            filter.operator == 'notbetween' &&
            isFixed(filter) === true
          "
          v-model="filter.value"
          size="mini"
          range-separator="To"
          start-placeholder="Start time"
          end-placeholder="End time"
          :picker-options="{
            format: 'HH:mm:ss',
          }"
          :value-format="'HH:mm'"
        ></el-time-picker>

        <el-time-picker
          v-model="filter.value"
          size="mini"
          placeholder="Select Time"
          v-if="
            filter.data_source == 'VALUE' &&
            filter.data_type == 'TIME' &&
            isFixed(filter) === false &&
            filter.operator != 'between'
          "
          :picker-options="{
            format: 'HH:mm:ss',
          }"
          :value-format="'HH:mm:ss'"
        ></el-time-picker>

        <el-time-select
          v-model="filter.value"
          v-if="
            filter.data_source == 'VALUE' &&
            filter.data_type == 'TIME' &&
            isFixed(filter) === true &&
            filter.operator != 'between'
          "
          placeholder="Select time"
          size="mini"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:59',
          }"
        ></el-time-select>

        <el-select
          v-model="filter.global_variable_id"
          v-if="filter.data_source == 'GLOBAL_VARIABLE'"
          no-data-text="No Global Varibles with Field"
          size="mini"
          @change="(value) => addGlobalVaraibleData(value, filter)"
        >
          <el-option
            v-for="(gbVab, index) of selectedGlobalVariablesList(filter)"
            :key="index"
            :label="`${gbVab.label} -> ${gbVab.value ? gbVab.value : ''}`"
            :value="gbVab._id"
          ></el-option>
        </el-select>

        <el-select
          v-if="
            filter.data_source == 'NEW_LIST' &&
            filter.operator != 'real_time' &&
            filter.operator != 'weekdays'
          "
          placeholder="Enter values"
          v-model="filter.value"
          :clearable="true"
          :allow-create="true"
          :default-first-option="true"
          :filterable="true"
          :multiple="true"
          :no-data-text="''"
          @change="(data) => parseOptionsAsNumbers(data, filter)"
          size="mini"
        />
        <el-select
          v-model="filter.value"
          v-if="filter.data_source == 'ENTITY_DATA_LIST'"
          multiple
          collapse-tags
          size="mini"
          filterable
        >
          <el-option
            v-for="(temp, i) in entilistAsOptions(filter)"
            :key="temp._id + '_' + index + '_' + i"
            :value="temp._id"
            :label="getLabel(temp, i)"
            >{{ getLabel(temp, i) }}</el-option
          >
        </el-select>

        <el-input
          v-if="
            (filter.data_source == '' || filter.data_source == undefined) &&
            filter.operator != 'between' &&
            filter.operator != 'notbetween' &&
            filter.operator != 'dateinclude' &&
            filter.operator != 'notdateinclude' &&
            filter.operator != 'real_time' &&
            filter.operator != 'weekdays' &&
            filter.operator == 'Equals'
          "
          v-model="filter.value"
          size="mini"
          :disabled="true"
        ></el-input>

        <el-select
          v-model="filter.value_field"
          v-if="filter.data_source == 'self_field'"
          collapse-tags
          size="mini"
        >
          <el-option
            v-for="(enityData, index) of getSelfTemplateFields(filter)"
            :key="index"
            :label="enityData.label"
            :value="enityData.key"
          ></el-option>
        </el-select>
        <el-select
          v-model="filter.value"
          v-if="filter.data_source == 'field_option'"
          collapse-tags
          size="mini"
          :multiple="
            filter.operator == 'in' || filter.operator == 'nin' ? true : false
          "
        >
          <template v-if="fieldType(filter, 'LIST')">
            <el-option
              v-for="(enityData, index) of getCurrentFieldOptions(filter)"
              :key="index + '_' + enityData.value"
              :label="enityData.name"
              :value="enityData.value"
              multiple
              collapse-tags
            ></el-option>
          </template>
          <template v-else-if="fieldType(filter, 'WEEKDAYS')">
            <el-option
              v-for="(option, index) of weekdays_options"
              :value="option.key"
              :label="option.name"
              :key="index"
            ></el-option>
          </template>
          <template v-else>
            <el-option
              v-for="(enityData, index) of getCurrentFieldOptions(filter)"
              :key="index"
              :label="enityData"
              :value="enityData"
              multiple
              collapse-tags
            ></el-option>
          </template>
        </el-select>
      </div>
    </td>
  </tr>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    components: {
    CustomDatePicker: () => import("@/components/widgets/customDatePicker.vue"),
  },
  computed:{
 ...mapGetters("auth", [
      "getDefaultDateFormat",
    ]),
  },
   props: [
    "filter",
    "index",
    "checkCurrentFieldData",
    "allFormbuilderFields",
    "getCurrentFieldOperators",
    "checkSourceDataChange",
    "allowedDataSources",
    "checkTemplateCondition",
    "checkIsSelect",
    "allowedLoginFilterOp",
    "getSelfTemplateFieldsByType",
    "weekdays_options",
    "checkIsFirstRelationalField",
    "checkCurrentFieldValue",
    "loginUserFields",
    "users",
    "isFixed",
    "addGlobalVaraibleData",
    "selectedGlobalVariablesList",
    "parseOptionsAsNumbers",
    "entilistAsOptions",
    "getLabel",
    "fieldType",
    "getCurrentFieldOptions",
   ],
}
</script>
